import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps';
import TableComponent from '../../../components/table/TableOps';
import EtiquetaLog from './EtiquetaLog';
import { Dialog, DialogActions, DialogContent, Button} from '@material-ui/core';
import ACCESS from '../../../ACCESS';

class EtiquetasGuia extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: `etiqueta/by-guia?id_guia=${this.props.match.params.id}`, deleteUrl: '', deleteField: '', modUrl: '' },
      TableOp.Table('Etiquetas de la guia', [
        { label: 'Folio', id: 'folio' },
        { label: 'Estatus', id: 'status' },
      ], [
        { id: 'edit', icon: 'history', access: [ACCESS.SEGUIMIENTO_ETIQUETAS.VER_ETIQUETAS_CREADAS_POR_EL_USUARIO, 
          ACCESS.SEGUIMIENTO_ETIQUETAS.VER_ETIQUETAS_SUCURSAL_DEL_USUARIO, ACCESS.SEGUIMIENTO_ETIQUETAS.VER_TODAS_ETIQUETAS] },
      ]))
    this.table();
  }

  action = async (id, row) => {
    if (id === 'edit') {
      this.setState({ dRow: row, dlOpen: true })
    }
  }


  render() {
    const { dRow, dlOpen } = this.state;
    return (
      <div>
        <this.TableRender />
          
        {/** Modal de historial de guia */}
        <Dialog
          maxWidth='md'
          open={dlOpen ? dlOpen : false}
          onClose={() => this.setState({ dlOpen: false })}
        >
          <DialogContent>
            <EtiquetaLog id_etiqueta={dRow ? dRow.id_etiqueta : ''} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ dlOpen: false })} color="primary">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withRouter(EtiquetasGuia)